// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Resources } from "../../../Commons/properties/Resources.js"
import { HistoryType } from "../../../Utils/History/HistoryType.ts"
import { CreateAlertWidgetTemplate } from "../../../templates.js";
import { Control } from "../../elements/Control.js";
import { ControlsTypes } from "../../UtilsClasses/FactoryConstants.js";
import { ThemeManager } from "../../misc/ThemeManager.js"
import { DataCache } from "../../../Commons/DataCache.js";
import { SessionSettings } from "../../../Commons/SessionSettings.js";

export let CreateAlertWidget = Control.extend({

    template: CreateAlertWidgetTemplate,
    data: function ()
    {
        return {
            quote: null,
            instrument: null,

            bidValue: NaN,
            askValue: NaN,
            lastValue: NaN,
            changeValue: NaN,
            volumeValue: NaN,

            bid_str_value: '',
            ask_str_value: '',
            last_str_value: '',
            change_str_value: '',
            volume_str_value: '',

            coloringBid: '#ffffff',
            coloringAsk: '#ffffff',
            coloringLast: '#ffffff',
            coloringChange: '#ffffff',
            coloringVolume: '#ffffff'
        }
    }
})

CreateAlertWidget.prototype.getType = function () 
{
    return ControlsTypes.CreateAlertWidget
}

CreateAlertWidget.prototype.oninit = function () 
{
    Control.prototype.oninit.call(this)
    Resources.onLocaleChange.Subscribe(this.localize, this)
    this.localize()

    this.observe('instrument', this.onInstrumentChanged)
}

CreateAlertWidget.prototype.dispose = function () 
{
    Resources.onLocaleChange.UnSubscribe(this.localize, this)

    this.unsubscribeQuotes(this.get('instrument'))

    Control.prototype.dispose.call(this)
}

CreateAlertWidget.prototype.onInstrumentChanged = function (instrument, lastInstrument)
{
    this.set({ bidValue: -1, askValue: -1, lastValue: -1, changeValue: -1, volumeValue: -1 });

    if (!instrument || instrument === lastInstrument)
        return

    this.unsubscribeQuotes(lastInstrument)
    this.subscribeQuotes(instrument)
}

CreateAlertWidget.prototype.onQuoteChanged = function (quote)
{
    let instrument = this.get('instrument');
    if (!instrument)
        return;

    let Level1 = instrument.Level1;
    if (!Level1)
        return;

    let MainAccount = SessionSettings.MainAccount;

    let bid = Level1.GetBid(MainAccount);
    let ask = Level1.GetAsk(MainAccount);
    let last = Level1.GetLastPrice(MainAccount);
    let change = Level1.GetChangePercent(MainAccount);
    let volume = Level1.GetVolume();//instrument.TotalVolume;

    let bidValue = this.get('bidValue');
    this.setColouring(bid, bidValue, "coloringBid")

    let askValue = this.get('askValue');
    this.setColouring(ask, askValue, "coloringAsk")

    let lastValue = this.get('lastValue');
    this.setColouring(last, lastValue, "coloringLast")

    let changeValue = this.get('changeValue');
    this.setColouring(change, changeValue, "coloringChange")

    let volumeValue = this.get('volumeValue');
    this.setColouring(volume, volumeValue, "coloringVolume")


    this.set({ bidValue: bid, askValue: ask, lastValue: last, changeValue: change, volumeValue: volume });
    this.set({
        bid_str_value: Level1.getFormatPrice(bid),
        ask_str_value: Level1.getFormatPrice(ask),
        last_str_value: Level1.getFormatPrice(last),
        change_str_value: Level1.formatChangePercentTostr(null, change),
        volume_str_value: Level1.strVolume(false)
    });
}

CreateAlertWidget.prototype.subscribeQuotes = function (instrument)
{
    if (!instrument)
        return

    this.newQuote(instrument.LastQuote)
    DataCache.FQuoteCache.addListener(instrument, this, HistoryType.QUOTE_LEVEL1)
    DataCache.FQuoteCache.addListener(instrument, this, HistoryType.QUOTE_TRADES)
}

CreateAlertWidget.prototype.unsubscribeQuotes = function (instrument)
{
    if (!instrument)
        return

    DataCache.FQuoteCache.removeListener(instrument, this, HistoryType.QUOTE_LEVEL1)
    DataCache.FQuoteCache.removeListener(instrument, this, HistoryType.QUOTE_TRADES)
    this.newQuote(null)
}

CreateAlertWidget.prototype.newQuote = function (quote)
{
    if (quote && quote.Type === HistoryType.QUOTE_INSTRUMENT_DAY_BAR)
        return;
    this.onQuoteChanged(quote);
}

CreateAlertWidget.prototype.setColouring = function (value, lastValue, coloringMode)
{
    let up = ThemeManager.CurrentTheme.TableValueUpForeColor;
    let down = ThemeManager.CurrentTheme.TableValueDownForeColor;
    let white = '#ffffff';

    if (isNaN(lastValue))
        this.set(coloringMode, white)
    else if (value > lastValue)
        this.set(coloringMode, up)
    else if (value < lastValue)
        this.set(coloringMode, down)
}

CreateAlertWidget.prototype.localize = function ()
{
    this.set('bidLabel', Resources.getResource('panel.watchlist.Bid'))
    this.set('askLabel', Resources.getResource('panel.watchlist.Ask'))
    this.set('lastLabel', Resources.getResource('panel.watchlist.Last'))
    this.set('changeLabel', Resources.getResource('panel.watchlist.ChangePr'))
    this.set('volumeLabel', Resources.getResource('panel.watchlist.Volume'))
}